import moment from 'moment';
import {
    currentCulture
} from './culture';

const timeUnit = {
    week: 'w',
    workWeek: 'Ww',
    day: 'd',
    workDay: 'wD',
    hour: 'h',
    minute: 'm',
    second: 's'
};

const resourceNameLookup = {
    w: 'Period_Week',
    wW: 'Period_WorkWeek',
    d: 'Period_Day',
    wD: 'Period_WorkDay',
    h: 'Period_Hour',
    m: 'Period_Minute',
    s: 'Period_Second'
}

const getUnitResource = (unit, duration) => {
    const baseResource = resourceNameLookup[unit];
    return duration && duration === 1 ? baseResource : baseResource + 's';
}

const secondsToTimeString = (secs, long = false, jira = false) => {
    const nl = currentCulture().name === 'nl';
    const duration = moment.duration(secs, 'seconds');
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    const hourString = jira ? `h ` : ` ${nl ? 'uur' : ' hours'} `;
    const minuteString = jira ? `m ` : ` ${nl ? 'minuten' : 'minutes'} `;
    const secondString = jira ? `s ` : ` ${nl ? ' seconden' : 'seconds'} `;

    return (jira || long) ? toLongDateTimeString(jira) :
        `${numberToString(hours)}:${numberToString(minutes)}:${numberToString(seconds)}`;

    function toLongDateTimeString(jira = false) {
        let result = '';
        
        if(hours !== 0 || days !== 0) {
            result = result +  `${hours+(days*24)}${hourString}`;
        }
        if(minutes != 0) {
            result = result +  `${minutes}${minuteString}`;
        }

        //If everything = 0, and this is for jira. We'll return 0m
        if(seconds === 0) {
            if(jira && hours === 0 && minutes === 0) {
                result = result +  `${seconds}${minuteString}`;
            }
        } else {
            result = result +  `${seconds}${secondString}`;
        }
        return result;
    }

    function numberToString(number) {
        return number  < 10 ? `0${number}` : `${number}`;
    }
};

const secondsToLongTimeString = (seconds) => { 
    return secondsToTimeString(seconds, true);
};

const secondsToJiraTimeString = (seconds) => { 
    return secondsToTimeString(seconds, false, true);
};

const dateToString = (date) => {
    return moment(new Date(date)).format('DD-MM-YYYY HH:mm:ss ');
};

const toSeconds = (value, unit) => {
    return unit === timeUnit.week ? value * 7 * 24 * 60 * 60 : 
        unit === timeUnit.workWeek ? value * 7 * 8 * 60 * 60 : 
        unit === timeUnit.day ? value * 24 * 60 * 60 : 
        unit === timeUnit.workDay ? value * 8 * 60 * 60 : 
        unit === timeUnit.hour ? value * 60 * 60 : 
        unit === timeUnit.minute ? value * 60 : unit === timeUnit.second ? value : 
        0;
};

const fromSeconds = (value, unit) => {
    return unit === timeUnit.week ? value / 7 / 24 / 60 / 60 : 
        unit === timeUnit.workWeek ? value / 7 / 8 / 60 / 60 : 
        unit === timeUnit.day ? value / 24 / 60 / 60 : 
        unit === timeUnit.workDay ? value / 8 / 60 / 60 : 
        unit === timeUnit.hour ? value / 60 / 60 : 
        unit === timeUnit.minute ? value / 60 : unit === timeUnit.second ? value : 
        0;
};

export {
    secondsToTimeString,
    secondsToLongTimeString,
    secondsToJiraTimeString,
    dateToString,
    toSeconds,
    fromSeconds,
    getUnitResource,
    timeUnit
};

export default {
    secondsToTimeString,
    secondsToLongTimeString,
    dateToString
};